<template>
    <vue-final-modal name="change-pwd-modal" class="verification-number-modal modal-common" v-model="show"
                     :width="'auto'" :click-to-close="false"
                     :height="'auto'" @before-open="handlerBeforeOpen" @before-close="handlerBeforeClose">
        <div class="modal-content-common modal-content-pwd">
            <div class="box-modal-header align-center">
                <div class="modal-title text-center w100p">비밀번호를 변경한지 90일이 경과했습니다.
                    <br>
                    비밀번호를 변경해주세요.
                </div>
            </div>
            <Form ref="passwordWriteFrom">
                <div>
                    <div class="box-row el-input-common">
                        <div class="box-title-common">현재 비밀번호</div>
                        <Field v-model="currentPwd" name="currentPwd" v-slot="{ field, errorMessage }"
                               :rules="validatePassword">
                            <el-input v-model="currentPwd" v-bind="field" name="pwd" maxlength="500"
                                      @input="checkPwd(currentPwd)"
                                      type="password" placeholder="현재 비밀번호 입력" clearable></el-input>
                            <div class="caption-common" v-if="errorMessage">{{ errorMessage }}</div>
                            <div class="caption-common" v-else-if="currentPwdError">{{ currentPwdError }}</div>
                        </Field>
                    </div>
                    <br>
                    <div class="box-row el-input-common">
                        <div class="box-title-common">변경 비밀번호</div>
                        <Field v-model="pwd" name="pwd" v-slot="{ field, errorMessage }" :rules="validatePassword">
                            <el-input v-model="pwd" v-bind="field" name="pwd" maxlength="500"
                                      @input="setData('pwd', pwd)"
                                      type="password" placeholder="변경 비밀번호 입력" clearable></el-input>
                            <div class="caption-common" v-if="errorMessage">{{ errorMessage }}</div>
                        </Field>
                    </div>
                    <br>
                    <div class="box-row el-input-common">
                        <div class="box-title-common">변경 비밀번호 확인</div>
                        <Field v-model="pwdConfirm" name="pwdConfirm" v-slot="{ field, errorMessage }"
                               :rules="validatePasswordConfirm">
                            <el-input v-model="pwdConfirm" v-bind="field" name="pwdConfirm" maxlength="500"
                                      @input="setData('pwdConfirm', pwdConfirm)" type="password"
                                      placeholder="변경 비밀번호 확인 입력" clearable
                                      @keypress.enter.native="checkValidate()"></el-input>
                            <div class="caption-common" v-if="errorMessage">{{ errorMessage }}</div>
                        </Field>
                    </div>
                </div>
            </Form>
            <div class="btn-wrap pt20 pb20">
                <el-button class="btn-blue" @click="checkValidate()">변경</el-button>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
import {Form, Field} from 'vee-validate';
import validateMixins from "@/mixins/validateMixins.js"
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";

export default {
    name: "ChangePwdModal",
    mixins: [validateMixins, alertMixins],
    components: {Form, Field,},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            show: false,
            pwd: '',
            pwdConfirm: '',
            currentPwd: '',
            currentPwdError: '',
            isRunState: false,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen() {
            this.showModal = true;
        },
        handlerBeforeClose() {
            this.pwd = '';
            this.pwdConfirm = ''
            this.currentPwd = ''
            this.showModal = false;
        },

        modalClose() {
            this.$vfm.hide('change-pwd-modal');
        },
        setData(key, value) {
            this[key] = value;
        },
        validatePassword(value) {
            if (this.isRequired(value)) {
                return "비밀번호를 입력해주세요.";
            }
            if (this.isPassword(value)) {
                return "비밀번호는 영문, 숫자, 특수문자를 포함한 8~16자로 입력해주세요";
            }
            return true;
        },
        validatePasswordConfirm(value) {
            if (this.isRequired(value)) {
                return "비밀번호를 재입력해주세요.";
            }
            if (this.isPassword(value)) {
                return "비밀번호는 영문, 숫자, 특수문자를 포함한 8~16자로 입력해주세요";
            }
            if (this.pwd !== value) {
                return "비밀번호가 일치하지 않습니다.";
            }
            return true;
        },
        async checkValidate() {
            if (this.isRunning) {
                return false;
            }
            let validateResult = await this.$refs.passwordWriteFrom.validate()
            this.isRunning = true;

            let isSuccess = validateResult.valid
            if (isSuccess) {
                await this.runSave()
            } else {
                this.errorAlert('입력 정보를 확인해주세요.');
                this.isRunning = false;
            }
        },
        async runSave() {
            if (!this.isRunState) {
                this.errorAlert('입력 정보를 확인해주세요.');
                return;
            }
            EventBus.$emit('apiLoading', true)
            let params = {
                mbPassword: this.pwd,
                mbPasswordConfirm: this.pwdConfirm
            }
            try {
                this.$api.$member.updateMemberPwd(params).then(res => {
                    let type = this.returnWriteType(res.code);
                    if (type !== true) {
                        EventBus.$emit('apiLoading', false)
                        this.errorAlert(type);
                        return false;
                    } else {
                        this.afterFunc();
                    }
                })
            } catch (e) {
                EventBus.$emit('apiLoading', false);
                console.log(e)
            }
        },

        async afterFunc() {
            const token = this.$localStorage.get('token');
            if (token) {
                await this.$store.dispatch('userInfo/setUserInfo', {token});
            }
            EventBus.$emit('apiLoading', false)
            this.createAlert({
                content: '비밀번호 변경 되었습니다.',
                hide: () => {
                    this.modalClose();
                    if (this.$route.path === '/auth') {
                        this.$router.push('/');
                    }
                }
            })
        },
        returnWriteType(type) {
            if (type === 1) {
                return true;
            } else {
                return '비밀번호 변경 실패하였습니다.'
            }
        },
        checkPwd() {
            if (this.currentPwd === '') {
                return;
            }
            try {
                this.$api.$member.chkPassword({'presentPassword': this.currentPwd}).then(res => {
                    if (res.code !== 1 || res.result.data !== true) {
                        this.currentPwdError = '비밀번호를 확인해주세요.';
                        this.isRunState = false;
                        return;
                    }
                    this.currentPwdError = '';
                    this.isRunState = true;
                })
            } catch (e) {
                EventBus.$emit('apiLoading', false);
                console.log(e)
            }
        },

    },
    watch: {},
    validators: {},
}
</script>

<style scoped></style>
